import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'ic-snacks'

export const TextAreaFloatingLabel = styled.label<{ focus: boolean }>`
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  color: ${({ focus }) => (focus ? colors.GREEN_500 : colors.GRAY_74)};
  z-index: 1;
`

export const TextAreaContainer = styled.div<{
  disabled: boolean
  focus: boolean
}>`
  position: relative;
  width: 100%;
  border-radius: 3px;
  border: 1px ${({ disabled }) => (disabled ? 'dashed' : 'solid')}
    ${({ focus }) => (focus ? colors.GREEN_500 : colors.GRAY_74)};
  padding: 10px;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 25px;
  padding-left: 0px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'inherit')};
  background: ${({ disabled }) => (disabled ? colors.GRAY_93 : colors.WHITE)};
  overflow: hidden;
`

const TextAreaElement = styled.textarea`
  position: relative;
  width: 100%;
  border-radius: 3px;
  outline: none;
  padding: 10px;
  font-size: 16px;
  border: none;
  color: ${({ disabled }) => (disabled ? colors.GRAY_46 : colors.GRAY_20)};
  background: ${({ disabled }) => (disabled ? colors.GRAY_93 : colors.WHITE)};
  resize: none;
`

interface TextAreaProps {
  name: string
  value: string
  onChange(e: React.ChangeEvent<HTMLTextAreaElement>): void
  labelText: React.ReactNode
  disabled: boolean
}

interface State {
  focus: boolean
}

class TextArea extends React.Component<TextAreaProps, State> {
  readonly state: State = {
    focus: false,
  }

  handleFocus = () => {
    this.setState({ focus: true })
  }

  handleBlur = () => {
    this.setState({ focus: false })
  }

  render() {
    const { disabled, labelText, ...rest } = this.props
    const { focus } = this.state

    return (
      <TextAreaContainer focus={focus} disabled={disabled}>
        <TextAreaFloatingLabel htmlFor="catalog-product__description" focus={focus}>
          {labelText}
        </TextAreaFloatingLabel>
        <TextAreaElement
          id="catalog-product__description"
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          disabled={disabled}
          {...rest}
          onChange={this.props.onChange}
        />
      </TextAreaContainer>
    )
  }
}

export default TextArea
